import React, { useEffect, useCallback } from 'react';
import './Notification.css';

/**
 * Модальный диалог подтверждения — замена window.confirm()
 * и кастомных модалок подтверждения.
 *
 * @param {boolean} open — показывать ли диалог
 * @param {string} title — заголовок
 * @param {React.ReactNode} children — сообщение / содержимое
 * @param {string} [confirmText='Подтвердить'] — текст кнопки подтверждения
 * @param {string} [cancelText='Отмена'] — текст кнопки отмены
 * @param {'danger'|'primary'} [variant='danger'] — стиль кнопки подтверждения
 * @param {boolean} [hideCancel=false] — скрыть кнопку отмены
 * @param {function} onConfirm — callback при подтверждении
 * @param {function} onCancel — callback при отмене
 */
const ConfirmDialog = ({
  open,
  title,
  children,
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
  variant = 'danger',
  hideCancel = false,
  onConfirm,
  onCancel,
}) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') onCancel?.();
    },
    [onCancel]
  );

  useEffect(() => {
    if (open) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [open, handleKeyDown]);

  if (!open) return null;

  const confirmBtnClass =
    variant === 'primary'
      ? 'confirm-dialog__btn confirm-dialog__btn--confirm-primary'
      : 'confirm-dialog__btn confirm-dialog__btn--confirm';

  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <button className="confirm-dialog__close" onClick={onCancel}>
          &times;
        </button>
        {title && <h2 className="confirm-dialog__title">{title}</h2>}
        <div className="confirm-dialog__message">{children}</div>
        <div className="confirm-dialog__actions">
          {!hideCancel && (
            <button
              className="confirm-dialog__btn confirm-dialog__btn--cancel"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button className={confirmBtnClass} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
